import { Cookies } from "react-cookie";
import { Maybe } from "@type/index";
import store from "@redux/store";
import { isPC } from "@util/helpers";

export const GUHK_TOKEN = "Uniqlo_token";
export const GUHK_REFRESH_TOKEN = "Uniqlo_refreshToken";
export const GUHK_EC_TOKEN = "ectoken";
export const GUHK_EC_REFRESH_TOKEN = "ecRefreshToken";

export const UQHK_SB_WISHLIST = "sb_hk_wishlist";

export const getLocalStorage = (key: string): Maybe<string> => {
  try {
    const res = localStorage.getItem(key);
    return res;
  } catch (e) {
    return null;
  }
};

export const deleteLocalStorage = (key: string) => {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    // Error case if required
  }
};

export const setLocalStorage = (key: string, data: string) => {
  try {
    localStorage.setItem(key, data);
  } catch (e) {
    // Do we need to handle exception of setItem?
  }
};

export function getIsLoggedIn(): boolean {
  const { isApp, region, brand_name } = store.getState().config;
  switch (`${brand_name.toUpperCase()}${region.toUpperCase()}`) {
    case "GUTW":
    case "UQTW":
    case "UQHK":
    case "GUHK": {
      if (isApp) {
        const cookies = new Cookies();
        let ectoken = cookies.get(GUHK_EC_TOKEN);
        const ecRefreshToken = cookies.get(GUHK_EC_REFRESH_TOKEN);
        if (ectoken || ecRefreshToken) {
          setLocalStorage(GUHK_TOKEN, ectoken);
          setLocalStorage(GUHK_REFRESH_TOKEN, ecRefreshToken);
        } else {
          ectoken = getLocalStorage(GUHK_TOKEN);
        }
        return !!(ectoken || ecRefreshToken);
      } else if (isPC(brand_name, region)) {
        const cookies = new Cookies();
        return !!cookies.get("access_token");
      } else {
        const _token = getLocalStorage(GUHK_TOKEN);
        return !!_token;
      }
    }
    default:
      return false;
  }
}

export function getToken(): string {
  const { region, brand_name } = store.getState().config;
  switch (`${brand_name.toUpperCase()}${region.toUpperCase()}`) {
    case "UQTW":
    case "GUTW":
    case "UQHK":
    case "GUHK": {
      if (isPC(brand_name, region)) {
        const cookies = new Cookies();
        return cookies.get("access_token") || "";
      } else {
        const _token = getLocalStorage(GUHK_TOKEN);
        return _token || "";
      }
    }
    default:
      return "";
  }
}
